module.exports = __webpack_public_path__ + "wp8_icons.7c946ef6ad278c8ecd54.png";


//////////////////
// WEBPACK FOOTER
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/external_css/kendo-ui/images/wp8_icons.png
// module id = ../../../../../external_css/kendo-ui/images/wp8_icons.png
// module chunks = styles